import GenericNoteLinkedGroupAdapter from 'notebook/notes/groups/GenericNoteLinkedGroupAdapter';
import {
  NotePartGridGroupMetadata,
  CreateNotePartGridGroupExtras,
} from 'notebook/notes/groups/note-part-grid/NotePartGridGroupConstants';
import {
  CreateNoteLinkedGroupProps,
  GroupActionFunctions,
  NoteLinkedGroup,
} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import {Schema} from 'schemas/SchemaConstants';

export class NotePartGridNoteLinkedGroupAdapter extends GenericNoteLinkedGroupAdapter<
  NotePartGridGroupMetadata,
  CreateNotePartGridGroupExtras
> {
  getDisplayName(group: NoteLinkedGroup<NotePartGridGroupMetadata>): string {
    return group.name || 'Grid Viewer';
  }

  // Required: Create the initial NoteParts when inserting a new group.
  createNoteParts(
    _createProps: CreateNoteLinkedGroupProps<NotePartGridGroupMetadata, CreateNotePartGridGroupExtras>
  ): Array<NotePart> {
    return []; // Empty because we will insert contained note parts after initial creation.
  }

  getGroupSchemas(_group: NoteLinkedGroup<NotePartGridGroupMetadata>): Array<Schema> {
    return []; // Empty because we don't have any schemas for the grid.
  }

  // Override action functions to be empty since we don't want to show any actions for the grid.
  override getActionFunctions(): GroupActionFunctions<
    NotePartGridGroupMetadata,
    CreateNotePartGridGroupExtras
  > {
    return {primary: undefined, secondary: [], overflow: [], footer: []};
  }
}
